import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/storage-scholars-services.jpg'),
    alt: 'storage scholars services page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'storage scholars services page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Storage <span>Scholars</span><span>Secure Storage Services</span>',
  description:
    'ShipAndStorage offers expert Storage Scholars Services designed for students and scholars seeking secure and flexible storage solutions. We ensure a hassle-free experience with professional handling and guaranteed security for your items.',
  points: [
    'Up to 6 Months Free Storage',
    'Free Insurance up to $250',
    '1 Small Box to 100 Large Box Storage',
    'Storage Services with Freedom'
  ],
  image: {
    url: '/images/v2/pages/landing-pages/storage-scholars-services/hero-image.svg',
    alt: 'storage scholars services page'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Sign Up for Scholar Storage' }
}

export const helperGuideSection = {
  title: 'How We Make Sure Reliable Storage Scholars Services',
  ctaButton: { href: PUBLIC_MAIN_ROUTES.HOW_SHIP_AND_STORAGE_WORKS.href, text: 'Learn More' },

  cards: [
    {
      id: 1,
      title: 'Book Your Storage',
      description:
        'Schedule your Storage Scholars Services with just a few clicks. Book online quickly and effortlessly, designed to fit into your busy student life.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-scholars-services/book-your-storage-service.svg',
        alt: 'Book Your Storage service'
      }
    },

    {
      id: 2,
      title: 'Ensure Safe Pickup & Delivery',
      description:
        'Trust our professional movers to safely transport your items—whether they’re fragile or oversized. Experience stress-free pickup and delivery with Storage Scholars Services.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-scholars-services/ensure-safe-pickup-&-delivery.svg',
        alt: 'Ensure Safe Pickup & Delivery service'
      }
    },
    {
      id: 3,
      title: 'Choose Flexible Storage Solutions',
      description:
        'Customize your storage plan to match your needs. From a few boxes to large items, our Storage Scholars Services offer tailored options to fit the size and duration of your storage.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-scholars-services/choose-flexible-storage-solutions.svg',
        alt: 'Choose Flexible Storage Solutions service'
      }
    },
    {
      id: 4,
      title: 'Affordable and Secure Storage Scholars Services',
      description:
        'At ShipAndStorage, we pride ourselves on offering Storage Scholars Services that are both affordable and secure. With student-friendly pricing and free insurance coverage up to $250, we ensure that your valuables are kept safe while offering the best value for your money.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-scholars-services/affordable-and-secure-storage-scholars-services.svg',
        alt: 'Affordable and Secure Storage Scholars Services service'
      }
    }
  ]
}

export const whySelfStorageSectionContent = {
  title: 'Why Self Storage Service Is Necessary?',

  cards: [
    {
      id: 1,
      title: 'Declutter and Refresh',
      description:
        'Open up valuable space in your home or office by storing less frequently used items. Our storage solutions help you maintain a neat and organized setting.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-scholars-services/declutter-and-refresh.svg',
        alt: 'Declutter and Refresh'
      }
    },
    {
      id: 2,
      title: 'Simplify Your Moving Process',
      description:
        'Easily manage your relocation by utilizing temporary storage for your belongings. Store your furniture and essentials until you’re ready to move them to your new space.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-scholars-services/simplify-your-moving-process.svg',
        alt: 'Simplify Your Moving Process'
      }
    },
    {
      id: 3,
      title: 'Secure Storage for Seasonal and Personal Valuables',
      description:
        'Keep your seasonal decor, sports gear, or important belongings safe in our secure facilities, with both short-term and long-term storage options available.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-scholars-services/secure-storage-for-seasonal-and-personal-valuables.svg',
        alt: 'Secure Storage for Seasonal and Personal Valuables'
      }
    }
  ]
}

export const gridSectionContent = {
  title: 'Who Should Choose ShipAndStorage Service for College Moving?',

  cards: [
    {
      id: 1,
      title: 'Students with Limited Dorm Space',
      description: 'Store extra items securely, like seasonal clothes or sports gear, to maximize dorm room space.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-scholars-services/students-with-limited-dorm-space.svg',
        alt: 'Students with Limited Dorm Space'
      }
    },
    {
      id: 2,
      title: 'Out-of-State and International Students',
      description: 'Keep belongings safe near campus without frequent transport costs and hassle.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-scholars-services/out-of-state-and-international-students.svg',
        alt: 'Out-of-State and International Students'
      }
    },
    {
      id: 3,
      title: 'Individuals with Seasonal Items',
      description: 'Store holiday decorations, winter gear, or summer equipment securely for easy access when needed.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-scholars-services/individuals-with-seasonal-items.svg',
        alt: 'Individuals with Seasonal Items'
      }
    },

    {
      id: 4,
      title: 'Business Owners',
      description: 'Safely store important documents, inventory, or equipment, freeing up valuable office space.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-scholars-services/business-owners.svg',
        alt: 'Business Owners'
      }
    },
    {
      id: 5,
      title: 'Homeowners in Transition',
      description: 'Store furniture and belongings securely during moves, renovations, or decluttering.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-scholars-services/homeowners-in-transition.svg',
        alt: 'Homeowners in Transition'
      }
    },
    {
      id: 6,
      title: 'Anyone Requiring Safe Storage',
      description: 'Keep personal valuables, memorabilia, or sensitive documents safe and accessible.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-scholars-services/anyone-requiring-safe-storage.svg',
        alt: 'Anyone Requiring Safe Storage'
      }
    }
  ]
}

export const evenOddList = {
  title: 'Our Different Storage Services',

  articles: [
    {
      id: 1,
      title: 'Business Storage Solution',
      description:
        'Our Storage Scholars Services also include secure business storage. Perfect for storing documents, office equipment, or inventory, we offer tailored storage options to keep your business assets safe and organized.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-scholars-services/business-storage-solution.svg',
        alt: 'Business Storage Solution'
      },
      link: {
        text: 'Explore Business Storage',
        href: PUBLIC_MAIN_ROUTES.BUSINESS_STORAGE.href
      }
    },
    {
      id: 2,
      title: 'Moving Storage Solution',
      description:
        "We provide flexible storage solutions during moves, ensuring that your belongings are stored safely until you're ready for them. Our moving storage solutions are ideal for students and scholars transitioning between locations.",
      image: {
        src: '/images/v2/pages/landing-pages/storage-scholars-services/moving-storage-solution.svg',
        alt: 'Moving Storage Solution'
      },
      link: {
        text: 'Explore Moving Storage',
        href: PUBLIC_MAIN_ROUTES.MOVING_STORAGE_SOLUTIONS.href
      }
    },
    {
      id: 3,
      title: 'Luggage and Box Shipping Services',
      description:
        'Need to ship your belongings? Our luggage and box shipping services, part of our <strong>Storage Scholars Services</strong>, are designed for both domestic and international shipping, offering fast, safe, and reliable transport.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-scholars-services/luggage-and-box-shipping-services-solution.png',
        alt: 'Luggage and Box Shipping Services'
      },
      link: {
        text: 'Explore Luggage & Box Shipping',
        href: PUBLIC_MAIN_ROUTES.LUGGAGE_BOX_SHIPPING_SERVICES.href
      }
    },
    {
      id: 4,
      title: 'Residential Storage Solution',
      description:
        "Our residential storage services are designed to store your personal and seasonal items securely for as long as you need. Whether it's summer break or an extended period, we offer flexible options that cater to your storage timeline.",
      image: {
        src: '/images/v2/pages/landing-pages/storage-scholars-services/business-storage-solution.svg',
        alt: 'Residential Storage Solution'
      },
      link: {
        text: 'Explore Residential Storage',
        href: PUBLIC_MAIN_ROUTES.RESIDENTIAL_STORAGE.href
      }
    }
  ]
}

export const whyChooseUsSectionContent = {
  title: 'Why Choose ShipAndStorage for Storage Scholars Services',

  cards: [
    {
      id: 1,
      title: 'Customizable Shipping Solutions',
      description:
        'Whether it’s a single piece of luggage or an entire dorm room, we provide flexible shipping options, including international services through our trusted partners, FedEx and DHL.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-scholars-services/customizable-shipping-solutions.svg',
        alt: 'Customizable Shipping Solutions'
      }
    },
    {
      id: 2,
      title: 'Door-to-Door Convenience',
      description:
        'Avoid the hassle of visiting storage centers. Our team will pick up and deliver your belongings straight to your door, ensuring maximum convenience for busy students.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-scholars-services/door-to-door-convenience.svg',
        alt: 'Door-to-Door Convenience'
      }
    },
    {
      id: 3,
      title: 'Cost-Effective Storage',
      description:
        'Only pay for the storage space your items require. With our affordable and tailored plans, you’ll never overspend on unused space, keeping your budget in check.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-scholars-services/cost-effective-storage.svg',
        alt: 'Cost-Effective Storage'
      }
    }
  ]
}

export const infoBannerSectionContent = {
  id: 1,
  title: 'Secure Storage Scholars Services for Students',
  description:
    'Storage Scholars services offer secure storage solutions. Fast, affordable, and reliable services for students needing storage.',
  image: {
    src: '/images/v2/pages/landing-pages/storage-scholars-services/secure-storage-scholars-services-for-students.svg',
    alt: 'Secure Storage Scholars Services for Students'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Get Started' }
}

export const faqSectionContent = {
  title: 'Our Shipping Partners',
  description:
    "ShipAndStorage proudly collaborates with leading global carriers, including FedEx, DHL, and UPS, to provide world-class shipping and storage services. Here's a quick overview of our reliable partners:",
  questions: [
    {
      id: 1,
      question: 'FedEx',
      answer:
        'Founded by Frederick W. Smith in 1971, FedEx has grown from handling 186 packages to becoming a global shipping giant. Today, FedEx operates a massive fleet of 696 aircraft and 215,000 vehicles, delivering 16 million shipments daily to over 220 countries and territories. With more than 550,000 employees and 5,000 centers worldwide, FedEx ensures fast and reliable service wherever you need it.|||Disclaimer|||This page was last updated in September 2024 for reference purposes only. FedEx makes no warranties, express or implied, regarding the accuracy or completeness of the information provided.|||For more details, visit FedEx.com. FedEx® is a registered trademark. © 1995-2024 FedEx.'
    },

    {
      id: 2,
      question: 'DHL',
      answer:
        'A division of Deutsche Post DHL Group, DHL Express is a global leader in international courier, parcel, and express mail services. Handling over 1.8 billion parcels annually, DHL operates in over 220 countries, keeping the global supply chain moving smoothly. Founded by Adrian Dalsey, Larry Hillblom, and Robert Lynn, DHL has been a trusted name in logistics since 1969.|||Disclaimer:|||This page was last updated in September 2024 and is provided for reference purposes only. DHL makes no warranties regarding the accuracy of the information provided.'
    },
    {
      id: 3,
      question: 'UPS',
      answer:
        'Originally established in 1907 as the American Messenger Company, UPS (United Parcel Service) has evolved into one of the largest global shipping firms. With over 500,000 employees and the ability to deliver 25 million packages daily to more than 220 countries, UPS provides unmatched global reach and dependability.|||Disclaimer:|||This page was last updated in September 2024 for reference purposes only. UPS makes no warranties regarding the accuracy of the information provided.'
    }
  ]
}
